export const toPersonPayload = values => ({
  email: values.email || '',
  phone: values.phone || '',
  details: values.details || ''
})
